/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap-touchspin';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/util';
import '../node_modules/bootstrap/js/src/collapse.js';
import SlickSlider from './components/slick';
import './lib/circle-progress.min.js';
import './lib/jquery.hoverIntent.min';
import './lib/slick.min';

import './cart';
import './checkout';
import './customer';
import './listing';
import './product';
import './responsive';

import Form from './components/form';
import TopMenu from './components/top-menu';

import EventEmitter from 'events';
import LocomotiveScroll from 'locomotive-scroll';
import prestashop from 'prestashop';

import 'lazysizes';

import $ from 'jquery';
import './components/block-cart';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const form = new Form();
  let slickSlider = new SlickSlider();
  let topMenuEl = $('#_desktop_top_menu #top-menu');
  let topMenu = new TopMenu(topMenuEl);

  form.init();
  slickSlider.init();
  topMenu.init();

  function displayParallax() {
    if ($('body#index').length === 0) return;
    const scroll = new LocomotiveScroll({
      el: document.querySelector('body#index main'),
      reloadOnContextChange: true,
      smooth: true,
      mobile: {
        breakpoint: 0,
        smooth: true,
      },
      tablet: {
        breakpoint: 0,
        smooth: true,
      },
    });

    $(window).on('resize', function () {
      if (window.matchMedia('(min-width: 992px)').matches) {
          scroll.destroy();
          scroll.init();
      }
    });
  }

  // $('#burger-menu .menu__item-header [data-toggle="collapse"]').on(
  //   'click',
  //   function () {
  //     const target = $(this).data('target');
  //     $('.menu-sub:not(' + target + ')').removeClass('show');
  //     //change [data-toggle="collapse"] aria-expanded value except the current one
  //     $('#burger-menu .menu__item-header [data-toggle="collapse"]').each(
  //       function () {
  //         if ($(this).data('target') !== target) {
  //           $(this).attr('aria-expanded', 'false');
  //         }
  //       }
  //     );
  //   }
  // );

  $('.search__toggle').on('click', () => {
    $('.header__search').toggleClass('header__search--active');
  });

  //display input file content in custom file input BS
  $('.custom-file-input').on('change', function () {
    let fileName = $(this).val().split('\\').pop();
    $(this).next('.custom-file-label').addClass('selected').html(fileName);
  });

  if ($('#nq_product_personalization').length > 0) {
    $('body').addClass('is-customizable');
  }

  function changeProductPageOnMobile() {
    if ($('#product').length === 0) return;
    const images = document.getElementById('content');

    if (window.matchMedia('(max-width: 991px)').matches) {
      document.querySelector('h1').after(images);
      if ($('.customization__switch .customization__label').length > 0) {
        $('.customization__switch .customization__label--label').text(
          'Personnaliser'
        );
        // $('.customization__switch .customization__label').addClass(
        //   'btn btn-black'
        // );
        // $('<i class="material-icons mr-2">&#xe429</i>').prependTo(
        //   '.customization__switch .customization__label--label'
        // );
      }
    } else {
      // annule les modifs quand on resize du mobile vers le desktop
      document.querySelector('.col__images').appendChild(images);
      if ($('.customization__switch .customization__label').length > 0) {
        $('nq_product_personalization:not(.short-personalization)  .customization__switch .customization__label--label').text(
          'Personnaliser le maillot'
        );
        $('nq_product_personalization.short-personalization .customization__switch .customization__label--label').text(
          'Personnaliser le short'
        );
        $('.customization__switch .customization__label').removeClass(
          'btn btn-black'
        );
      }
    }
  }

  function refreshCustomizerPrice() {
    var $options = $('.flocage-price-option');
    $options.on('change', () => {
      let price = 0;
      $options.each((i, elm) => {
        if (elm.checked)
          price += parseFloat(elm.getAttribute('data-flocage-price'));
      });
      displayCustomizerPrice(price);
    });
  }

  function displayCustomizerPrice(price = 0) {
    var totalPrice = $('.current-price').data('price').replace('€', '');
    totalPrice = totalPrice.replace(/\s/g, '');
    totalPrice = parseFloat(totalPrice);
    var displayPrice = totalPrice + price;

    if (price > 0) {
      $('.price-personalization').html(price + '&nbsp;€');
      $('.price-personalization').show();
      $('.customizerPrice').removeClass('d-none');
      $('.price-total').html(displayPrice + '&nbsp;€');
      $('.totalPrice').removeClass('d-none');
    } else {
      $('.customizerPrice ').addClass('d-none');
      $('.totalPrice ').addClass('d-none');
    }
  }

  changeProductPageOnMobile();
  refreshCustomizerPrice();
  displayParallax();

  $(window).on('resize', function () {
    changeProductPageOnMobile();
  });

  prestashop.on('updatedCart', function (event) {
    if (event.resp.cart_shipping_free) {
      let progressBarOptions = {
        startAngle: -1.55,
        size: 120,
        thickness: 4,
        value: $('.circle').attr('value'),
        fill: {
          color: '#ea670b',
        },
      };

      $('.freeShipping__wrapper').replaceWith(event.resp.cart_shipping_free);
      $('.circle').circleProgress(progressBarOptions);
    }
    if (event.resp.cart_featured_products) {
      $('.cart-featured-products').replaceWith(
        event.resp.cart_featured_products
      );
    }
  });
});

document.addEventListener('lazyloaded', function (e) {
  $(e.target).parent().addClass('rc--lazyload');
});
